import { render, staticRenderFns } from "./StoreManage.vue?vue&type=template&id=5b140fe5&scoped=true"
import script from "./StoreManage.vue?vue&type=script&lang=js"
export * from "./StoreManage.vue?vue&type=script&lang=js"
import style0 from "./StoreManage.vue?vue&type=style&index=0&id=5b140fe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b140fe5",
  null
  
)

export default component.exports